module.exports = __webpack_public_path__ + "img/bank-mandiri.6ad01112.png";